import { platform } from "utils/api/generated/manucoApi";

// GET /v2/overview/process-status?legalEntity= -> { period, banks[] (met legalEntities), totals, worklist }
// legalEntity leeg = alle entiteiten (zoals de sidebar-badges).
export async function getProcessStatus(tokenProvider, { legalEntity } = {}) {
  const payload = await platform.processStatusGet(tokenProvider, legalEntity ? { legalEntity } : {});
  return payload && typeof payload === "object" ? payload : null;
}
